import { cn } from "@/lib/cn";

export interface SpinnerProps {
  size?: number;
  className?: string;
  /** Vorlesetext. Nur setzen, wenn der Ladevorgang nicht schon anderswo benannt ist. */
  label?: string;
}

/**
 * Ladeanzeige.
 *
 * Die Drehung läuft auch bei `prefers-reduced-motion`, nur langsamer — siehe
 * `.spinner-arc` in styles.css. Eine stehende Ladeanzeige wäre kein
 * Entgegenkommen, sondern sähe nach einer eingefrorenen Anwendung aus.
 */
export function Spinner({ size = 20, className, label }: SpinnerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={cn("spinner-arc shrink-0", className)}
      role={label ? "status" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : true}
      focusable="false"
    >
      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" strokeWidth={2.5} opacity={0.22} />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        fill="none"
        stroke="currentColor"
        strokeWidth={2.5}
        strokeLinecap="round"
      />
    </svg>
  );
}
